var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestrictIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7141 3.28596C13.9205 4.49239 14.6667 6.15905 14.6667 8C14.6667 11.6819 11.682 14.6667 8.00004 14.6667C6.15909 14.6667 4.49243 13.9204 3.286 12.7141M12.7141 3.28596C11.5077 2.07953 9.841 1.33334 8.00004 1.33334C4.31814 1.33334 1.33337 4.31811 1.33337 8C1.33337 9.84097 2.07957 11.5076 3.286 12.7141M12.7141 3.28596L3.286 12.7141",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictIcon);
export default __webpack_public_path__ + "static/media/restrict_icon.03a80e05824fa00e822f6f32502dc91d.svg";
export { ForwardRef as ReactComponent };